import { getResumeOrSectionIndex, onSubmit } from '../../handlers';

export const handleChange = (stateProps, formikProps, index, qObj, newValue) => {
  formikProps.values.jobSeekerData[index][qObj.qid] = newValue;
  onSubmit(formikProps, stateProps);
};
export const handleNewSelect = (stateProps, formikProps, qObj) => {
  const addButton = document.querySelector('#addAnother_' + qObj.qid);
  const value = addButton.value;
  let add = value.trim().length > 0;
  if (qObj.options) {
    for (let i = 0; i < qObj.options.length; i++) {
      if (qObj.options[i].key === value) {
        add = false;
        break;
      }
    }
  }
  if (add) {
    const newCheckBoxValue = { label: value, key: value, value: value };
    qObj.options.push(newCheckBoxValue);
    const index = getResumeOrSectionIndex(stateProps, formikProps);
    if (!formikProps.values.jobSeekerData[index][qObj.qid]) {
      formikProps.values.jobSeekerData[index][qObj.qid] = [];
    }
    formikProps.values.jobSeekerData[index][qObj.qid].push(value);
    let counter = stateProps.counter;
    stateProps.setCounter(counter + 1);
  }
  addButton.value = '';
};
